<template>
  <div>
    <MemberLayout activeLink="website">
      <div class="container">
        <div class="row">
          <div class="col-12">
            <FordaysBannerLogo />
          </div>
          <div class="col-12">
            <a class="member-main-btn" target="_blank" href="http://www.fordays.com.tw">
              <i class="fas fa-tv"></i>
              <span class="member-main-btn-text">公司網站</span>
            </a>
          </div>
          <div class="col-12">
            <a class="member-main-btn" target="_blank" href="https://www.facebook.com/fordays.tw">
              <i class="fab fa-facebook-square"></i>
              <span class="member-main-btn-text">公司FACEBOOK</span>
            </a>
          </div>
          <div class="col-12">
            <a class="member-main-btn" target="_blank" href="https://fordays.jp">
              <i class="fas fa-tv"></i>
              <span class="member-main-btn-text">日本總公司網站</span>
            </a>
          </div>
        </div>
      </div>
    </MemberLayout>
  </div>
</template>
<script>
import MemberLayout from "../../components/member/MemberLayout";
import FordaysBannerLogo from "../../components/member/FordaysBannerLogo";
export default {
  name: "WebsiteScreen",
  components: {
    MemberLayout,
    FordaysBannerLogo
  }
};
</script>